import { render, staticRenderFns } from "./DemoList.vue?vue&type=template&id=2ae88fd0"
import script from "./DemoList.vue?vue&type=script&lang=js"
export * from "./DemoList.vue?vue&type=script&lang=js"
import style0 from "./DemoList.vue?vue&type=style&index=0&id=2ae88fd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports